/**
 * A class that can return the Appraisal model
 */
export class Appraisal {
  /** @param {Object} appraisal FastJson object. */
  constructor(appraisal = {}) {
    this.id = appraisal.id || null;

    if (appraisal.attributes) {
      this.status = appraisal.attributes.status || null;
      this.title = appraisal.attributes.appraisal_template_name || null;
      this.employeeId = appraisal.attributes.employee_id || null;
      this.employeeName = appraisal.attributes.employee_name || null;
      this.supervisorId = appraisal.attributes.supervisor_id || null;
      this.supervisorName = appraisal.attributes.supervisor_name || null;
      this.appraisalTemplateId = appraisal.attributes.appraisal_template_id || null;
      this.createdById = appraisal.attributes.created_by_id || null;
      this.completedAt = appraisal.attributes.completed_at || null;
      this.createdAt = appraisal.attributes.created_at || null;
      this.updatedAt = appraisal.attributes.updated_at || null;
      this.canEdit = appraisal.attributes.can_edit || false;
      this.questions = (appraisal.attributes.questions || []).map((question) => ({
        id: question.id,
        body: question.body,
        questionType: question.question_type,
        isScored: question.is_scored,
        weight: question.weight,
        position: question.position,
        options: (question.options || []).map((option) => ({
          id: option.id,
          body: option.body,
          position: option.position,
          score: option.score
        })),
        answers: {
          employee: question.answers.employee,
          supervisor: question.answers.supervisor,
          meeting: question.answers.meeting
        }
      }));
    }
  }
}
